import useGlobalQueries from './useGlobalQueries';

export default (feature, isLearner = false) => {
  const { adminSettings, learnerSettings } = useGlobalQueries();
  const query = isLearner ? learnerSettings : adminSettings;
  const { data } = query;
  const enabledFeatures = data?.enabled_features || [];
  const isLabsModuleEnabled = Boolean(enabledFeatures.find((code) => code === 'labs_module'));
  const isLabsFeatureEnabled = Boolean(data?.labs_features?.find(({ code }) => code === feature));
  return isLabsModuleEnabled && isLabsFeatureEnabled;
};
